import { __awaiter } from "tslib";
import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, KeepAlive as _KeepAlive, createTextVNode as _createTextVNode, withCtx as _withCtx, Fragment as _Fragment, withModifiers as _withModifiers, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-12aa1063"), n = n(), _popScopeId(), n);
const _hoisted_1 = { class: "title" };
const _hoisted_2 = { key: 0 };
const _hoisted_3 = /*#__PURE__*/ _createTextVNode(" Loading.... ");
const _hoisted_4 = { style: { "display": "flex" } };
const _hoisted_5 = ["onClick"];
const _hoisted_6 = { class: "btn-txt" };
import { ref } from 'vue';
import Alert from '@/materials/atoms/Alert.vue';
import VerifyOnetimePasscode from '@/components/organisms/modal/VerifyOnetimePasscode.vue';
import ApiAccessTokens from './MypageApiManagement/ApiAccessTokens.vue';
import { useApiApproval, APPROVAL_STATUS_ACTIVE, APPROVAL_STATUS_WAITING, APPROVAL_STATUS_REJECT, APPROVAL_STATUS_SUSPENDED, } from '@/logics/api_approval';
import { useOneTimePasscode } from '@/logics/one_time_passcode';
import { useMessage } from '@/const/messages';
import ApiRoleList from '../../modal/ApiRoleList.vue';
export default /*#__PURE__*/ _defineComponent({
    props: {
        displayTitle: null,
        userInfo: null
    },
    setup(__props) {
        const props = __props;
        const apiApproval = ref();
        const isLoading = ref(false);
        const isShowModal = ref(false);
        const isShowApiRoleModal = ref(false);
        const { MYPAGE_API_MANAGEMENT, format } = useMessage();
        const { getApiApproval, postApiApproval, isLoading: isLoadingApiApproval } = useApiApproval();
        const { checkVerified } = useOneTimePasscode();
        const initialize = () => __awaiter(this, void 0, void 0, function* () {
            var _a;
            if (!((_a = props.userInfo) === null || _a === void 0 ? void 0 : _a.kyc))
                return;
            apiApproval.value = yield getApiApproval();
        });
        const onVerifiedOnetimePasscode = () => __awaiter(this, void 0, void 0, function* () { return (apiApproval.value = yield postApiApproval()); });
        const showModal = () => __awaiter(this, void 0, void 0, function* () {
            if (isLoading.value)
                return;
            try {
                isLoading.value = true;
                yield checkVerified();
                yield onVerifiedOnetimePasscode();
            }
            catch (err) {
                if (err.response.status == 404) {
                    isShowModal.value = true;
                }
                else {
                    console.error(err);
                }
            }
            finally {
                isLoading.value = false;
            }
        });
        const showApiRoleModal = () => __awaiter(this, void 0, void 0, function* () { return (isShowApiRoleModal.value = true); });
        const onClose = () => (isShowModal.value = false);
        const onCloseApiRoleModal = () => (isShowApiRoleModal.value = false);
        initialize();
        return (_ctx, _cache) => {
            var _a;
            return (_openBlock(), _createElementBlock(_Fragment, null, [
                _createElementVNode("div", _hoisted_1, [
                    _createElementVNode("div", null, _toDisplayString(_unref(format)(props.displayTitle)), 1),
                    (!!apiApproval.value && (apiApproval.value.approval_status === _unref(APPROVAL_STATUS_ACTIVE) || apiApproval.value.approval_status === _unref(APPROVAL_STATUS_WAITING)))
                        ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                            _createElementVNode("a", {
                                href: "#",
                                class: "link",
                                onclick: showApiRoleModal
                            }, _toDisplayString(_unref(format)(_unref(MYPAGE_API_MANAGEMENT).LINK_ABOUT_API)), 1)
                        ]))
                        : _createCommentVNode("", true)
                ]),
                (_openBlock(), _createBlock(_KeepAlive, null, [
                    (isShowApiRoleModal.value)
                        ? (_openBlock(), _createBlock(ApiRoleList, {
                            key: 0,
                            onClose: onCloseApiRoleModal
                        }))
                        : _createCommentVNode("", true)
                ], 1024)),
                (!((_a = props.userInfo) === null || _a === void 0 ? void 0 : _a.kyc))
                    ? (_openBlock(), _createBlock(Alert, {
                        key: 0,
                        "color-mode": "error"
                    }, {
                        default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_unref(format)(_unref(MYPAGE_API_MANAGEMENT).ALERT_KYC)), 1)
                        ]),
                        _: 1
                    }))
                    : (_unref(isLoadingApiApproval))
                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                            _hoisted_3
                        ], 64))
                        : (!!apiApproval.value && apiApproval.value.approval_status === _unref(APPROVAL_STATUS_ACTIVE))
                            ? (_openBlock(), _createBlock(ApiAccessTokens, { key: 2 }))
                            : (!!apiApproval.value && apiApproval.value.approval_status === _unref(APPROVAL_STATUS_WAITING))
                                ? (_openBlock(), _createBlock(Alert, {
                                    key: 3,
                                    "color-mode": "warning"
                                }, {
                                    default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(_unref(format)(_unref(MYPAGE_API_MANAGEMENT).ALERT_WAITING)), 1)
                                    ]),
                                    _: 1
                                }))
                                : (!!apiApproval.value &&
                                    (apiApproval.value.approval_status === _unref(APPROVAL_STATUS_REJECT) ||
                                        apiApproval.value.approval_status === _unref(APPROVAL_STATUS_SUSPENDED)))
                                    ? (_openBlock(), _createBlock(Alert, {
                                        key: 4,
                                        "color-mode": "error"
                                    }, {
                                        default: _withCtx(() => [
                                            _createTextVNode(_toDisplayString(_unref(format)(_unref(MYPAGE_API_MANAGEMENT).ALERT_REJECT)), 1)
                                        ]),
                                        _: 1
                                    }))
                                    : (_openBlock(), _createElementBlock(_Fragment, { key: 5 }, [
                                        (isShowModal.value)
                                            ? (_openBlock(), _createBlock(VerifyOnetimePasscode, {
                                                key: 0,
                                                onSubmitted: onVerifiedOnetimePasscode,
                                                onClose: onClose
                                            }))
                                            : _createCommentVNode("", true),
                                        _createElementVNode("div", _hoisted_4, [
                                            _createElementVNode("button", {
                                                class: "act-btn",
                                                onClick: _withModifiers(showModal, ["prevent"])
                                            }, [
                                                _createElementVNode("span", _hoisted_6, _toDisplayString(_unref(format)(_unref(MYPAGE_API_MANAGEMENT).BTN_APPLY)), 1)
                                            ], 8, _hoisted_5)
                                        ])
                                    ], 64))
            ], 64));
        };
    }
});
